import { render, staticRenderFns } from "./ClassSupport.vue?vue&type=template&id=144f8d94&scoped=true"
import script from "./ClassSupport.vue?vue&type=script&lang=js"
export * from "./ClassSupport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "144f8d94",
  null
  
)

export default component.exports